module.exports = __webpack_public_path__ + "img/ab-page2-img3.6aa605e7.png";